import { Upload } from 'tus-js-client';
import { api } from '../../hooks/useApi';
import { percentSent } from '../../lib/videos';

// Bunny's recommended waits (ms) between tries after a dropped connection.
// Each retry carries on from what Bunny already has.
const RETRY_DELAYS = [0, 3000, 5000, 10000, 20000, 60000, 60000];

// Sends one video straight from the browser to Bunny. Our backend only signs
// the upload. Returns { url, name } to save on the activity.
export const uploadVideo = async (file, onPercent) => {
  const video = await api.post('/sales/videos', { name: file.name, size: file.size });
  await new Promise((resolve, reject) => {
    new Upload(file, {
      endpoint: video.upload.endpoint,
      headers: video.upload.headers,
      metadata: { filetype: file.type || 'video/mp4', title: video.name },
      retryDelays: RETRY_DELAYS,
      storeFingerprintForResuming: false, // each upload is a new video at Bunny
      onProgress: (sent, total) => onPercent?.(percentSent(sent, total)),
      onError: reject,
      onSuccess: resolve,
    }).start();
  });
  return { url: video.url, name: video.name };
};
